import { createAction, props } from '@ngrx/store';

export const loadProofOfAddressDocumentTypes = createAction('[ProofOfAddressDocumentTypes] Load ProofOfAddressDocumentTypes');

export const loadProofOfAddressDocumentTypesSuccess = createAction(
  '[ProofOfAddressDocumentTypes] Load ProofOfAddressDocumentTypes Success',
  props<{ response: any }>()
);

export const loadProofOfAddressDocumentTypesFailure = createAction(
  '[ProofOfAddressDocumentTypes] Load ProofOfAddressDocumentTypes Failure',
  props<{ error: Error | any }>()
);
